// Base service name
export const SERVICE_NAME = "RESPONSIVE_SERVICE";
